import { render, staticRenderFns } from "./PostCharge.vue?vue&type=template&id=a61b0c4e"
import script from "./PostCharge.vue?vue&type=script&lang=js"
export * from "./PostCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports